// utils/chartDataTransform.js
export function transformChartData({ data, segmentDimensions, analyticsQuery }) {
  const { name, availableMetrics } = analyticsQuery
  if (!data || data.length === 0) {
    return { traces: [], categories: [], series: [] };
  }

  const sortedData = _.orderBy(data, ['time'], ['asc']);

  if (segmentDimensions && segmentDimensions.length > 0) {
    const pivotKey = _.camelCase(segmentDimensions[0]);

    // Get all unique times and series values
    const allTimes = [...new Set(sortedData.map(d => d.time))].sort();
    const allSeries = [...new Set(sortedData.map(d => d[pivotKey]))].filter(Boolean);

    // Create a lookup map for quick access
    const dataMap = {};
    sortedData.forEach(row => {
      const key = `${row.time}_${row[pivotKey]}`;
      dataMap[key] = row.count || 0;
    });

    return {
      categories: allTimes,
      series: getSeries(availableMetrics, allSeries).map(s => s.label),
      dataMap,
      pivotKey,
      getValueAt: (time, series) => {
        const key = `${time}_${series}`;
        return dataMap[key] || 0;
      }
    };
  } else {
    // Non-pivoted data - each numeric column is a series
    const seriesKeys = Object.keys(sortedData[0]).filter(
      key => key !== 'time' && typeof sortedData[0][key] === 'number'
    );

    return {
      categories: sortedData.map(d => d.time),
      series: getSeries(availableMetrics, seriesKeys),
      data: sortedData,
      title: name,
      getValueAt: (index, series) => sortedData[index]?.[series] || 0
    };
  }
}

function getSeries(availableMetrics, columnNames) {
  return columnNames.map((columnName, index) => {
    const metric = availableMetrics.find(m => _.camelCase(m.columnName) === columnName);

    return {
      label: metric ? metric.label : _.startCase(columnName),
      columnName: columnName,
      key: columnName,
      color: chartColors[index % chartColors.length],
    };
  })
}

// Shared color palette
export const chartColors = [
  '#7FD1E0', // Indigo
  '#5FD092', // Rose
  '#E69900', // Emerald
  '#8b5cf6', // Violet
  '#06b6d4', // Cyan
  '#ec4899', // Pink
  '#14b8a6', // Teal
];

export const chartStyles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    border: '1px solid #f3f4f6'
  },
  title: {
    font: {
      size: 20,
      color: '#1f2937',
      family: 'Inter, system-ui, sans-serif',
      weight: 600
    },
    x: 0,
    xanchor: 'left',
    pad: { l: 0 }
  },
  legend: {
    orientation: 'h',
    yanchor: 'bottom',
    y: -0.3,
    xanchor: 'center',
    x: 0.5,
    font: {
      size: 11,
      color: '#4b5563'
    },
    bgcolor: 'rgba(255,255,255,0.9)',
    bordercolor: '#e5e7eb',
    borderwidth: 1
  }
};
